module.exports = "<div ui-view>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/sale/templates/index.html
// module id = 1618
// module chunks = 0